import React from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import LoadMask from "Utils/LoadMask/LoadMask";
import { RenderNumberPercentage } from "../../../../../Utils/renderField/renderReadField";
import { formatWithMinDigits } from "../../../../../../../utility/utils";

export const ModalRepeticionAnalisis = ({ repeticion }) => {
    const {
        modalAbierto,
        solicitud,
        disponibilidadBulto,
        requiereConfirmarDato,
        datoCorrectoConfirmado,
        register,
        CerrarModal,
        ConfirmarRepeticion,
        cargando,
    } = repeticion;

    if (!solicitud) {
        return null;
    }

    return (
        <Modal
            open={modalAbierto}
            onClose={CerrarModal}
            closeOnOverlayClick={false}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "600px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <form
                    onSubmit={ConfirmarRepeticion}
                    className="repeticion-analisis__modal"
                >
                    <h4 className="text-center mb-3">Repetir análisis</h4>

                    <div className="formulario-fields-row my-0">
                        <div className="formulario-field text-center">
                            <label>ID de solicitud</label>
                            <span>{formatWithMinDigits(solicitud.id)}</span>
                        </div>
                        <div className="formulario-field text-center">
                            <label>Tipo</label>
                            <span>{solicitud.tipo_display}</span>
                        </div>
                        <div className="formulario-field text-center">
                            <label>Fecha de solicitud</label>
                            <span>
                                {moment(
                                    solicitud.fecha_solicitud_analisis,
                                ).format("DD/MM/YYYY HH:mm")}
                            </span>
                        </div>
                        <div className="formulario-field text-center">
                            <label>DRC validado</label>
                            <RenderNumberPercentage
                                value={solicitud.drc_final}
                                decimalScale={3}
                            />
                        </div>
                    </div>

                    <div className="alert alert-warning text-center mt-3 mb-0 bold">
                        Se eliminarán los datos registrados en este análisis
                        (muestras, contaminantes, DRC y observaciones). La
                        solicitud quedará pendiente de análisis, deberá
                        analizarse y validarse nuevamente.
                    </div>

                    {requiereConfirmarDato && (
                        <React.Fragment>
                            <div className="alert alert-danger text-center mt-3 mb-2">
                                {disponibilidadBulto.bulto_descartado
                                    ? "El bulto skim fue descartado, por lo que no es posible tomar una nueva muestra."
                                    : "El bulto skim ya se utilizó por completo, por lo que no es posible tomar una nueva muestra."}
                            </div>
                            <div className="d-flex align-items-center gap-10">
                                <input
                                    type="checkbox"
                                    className="checkbox"
                                    id="dato_correcto_confirmado"
                                    {...register("dato_correcto_confirmado")}
                                />
                                <label
                                    htmlFor="dato_correcto_confirmado"
                                    className="m-0 pl-0"
                                >
                                    Tengo registrado el dato correcto para este
                                    bulto skim
                                </label>
                            </div>
                        </React.Fragment>
                    )}

                    <div className="mt-3">
                        <label className="mb-1">Motivo (opcional)</label>
                        <textarea
                            style={{ resize: "none" }}
                            rows={3}
                            className="form-control"
                            {...register("motivo")}
                        />
                    </div>

                    <div className="d-flex justify-content-center gap-10 mt-4 mb-2">
                        <button
                            type="button"
                            className="btn btn-outline-dark"
                            onClick={CerrarModal}
                        >
                            Regresar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={
                                requiereConfirmarDato && !datoCorrectoConfirmado
                            }
                        >
                            Repetir análisis
                        </button>
                    </div>
                </form>
            </LoadMask>
        </Modal>
    );
};
